import type { SVGProps } from 'react';

export function CalendarSmallIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="2"
        width="9"
        height="9"
        rx="1"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M4 1v2M8 1v2"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path d="M1.5 5h9" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}
